import { PropertyTypeSlug, TextCase } from "./constants";

export const nounForPropertyTypeSlug = (
  propertyTypeSlug: PropertyTypeSlug,
  textCase: TextCase = TextCase.Lowercase,
) => {
  const noun = propertyTypeSlug === PropertyTypeSlug.House ? "House" : "Unit";

  switch (textCase) {
    case TextCase.Capitalised:
      return noun;
    case TextCase.Lowercase:
      return noun.toLowerCase();
    case TextCase.Uppercase:
      return noun.toUpperCase();
  }
};

export function formatPrice(price: number | undefined) {
  if (price === undefined || price === null) return "N/A";
  if (price >= 1000000) {
    return `$${Number(price / 1000000).toPrecision(3)}M`;
  }
  if (price >= 1000) {
    return `$${Number(price / 1000).toPrecision(3)}K`;
  }
  return `$${Number(price).toFixed(0)}`;
}

export function formatPriceDetailed(price: number | undefined) {
  if (price === undefined || price === null) return "N/A";

  return new Intl.NumberFormat("en-AU", {
    style: "currency",
    currency: "AUD",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(price);
}
